import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ResetPassword } from '../../../models/reset-password';
import { AlertaService } from '../../../services/alerta.service';
import { saveResetPasswordAct } from '../../../store/reset-password/reset-password.actions';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, map } from 'rxjs';

@Component({
  selector: 'app-password-reset',
  standalone: false,
  templateUrl: './password-reset.component.html',
  styleUrl: './password-reset.component.css'
})
export class PasswordResetComponent {

  resetPassword: ResetPassword;
  loading: boolean = false;

  constructor(private router: Router, 
    private alerta: AlertaService, 
    private resetPasswordRdcStore: Store<{ resetPasswordRdc: any }>
  ) {
    this.resetPassword = new ResetPassword();

    this.resetPasswordRdcStore.pipe(
      select('resetPasswordRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        loading: state.loading
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ loading }) => {
      this.loading = loading;
    });

  }

  onSubmit() {
    if (!this.resetPassword.email) {
      this.alerta.error("Email es Requerido.");
    } else {
      //this.loading = true;
      this.resetPasswordRdcStore.dispatch(saveResetPasswordAct({ resetPasswordNew: this.resetPassword }))
      //this.resetPassword = new ResetPassword();
    }
  }

  onCancel() {
    this.router.navigate(['/login']);
  }
}
